(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  // Reveal the sound toggle once the customer starts playback from a poster image.
  const playButton = event.target.closest('[ref="deferredMediaPlayButton"]');
  if (playButton) {
    const container = playButton.closest('deferred-media');
    const soundToggle = container && container.querySelector('[data-sound-toggle]');
    if (soundToggle) soundToggle.classList.remove('hidden');
    return;
  }

  const button = event.target.closest('[data-sound-toggle]');
  if (!button) return;

  const media = document.getElementById(button.getAttribute('data-video-id'));
  if (!media) return;

  const isCurrentlyMuted = button.getAttribute('aria-pressed') !== 'true';
  const willUnmute = isCurrentlyMuted;

  if (media.tagName === 'VIDEO') {
    media.muted = !willUnmute;
    if (willUnmute) media.play().catch(() => {});
  } else if (media.tagName === 'IFRAME' && media.contentWindow) {
    const videoType = media.getAttribute('data-video-type');
    if (videoType === 'youtube') {
      media.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: willUnmute ? 'unMute' : 'mute', args: '' }),
        '*'
      );
    } else if (videoType === 'vimeo') {
      media.contentWindow.postMessage(
        JSON.stringify({ method: 'setVolume', value: willUnmute ? 1 : 0 }),
        '*'
      );
    }
  }

  button.setAttribute('aria-pressed', String(willUnmute));
  button.setAttribute(
    'aria-label',
    willUnmute ? 'Turn sound off' : 'Turn sound on'
  );
});
  } catch(e) { console.error(e); }
})();

})();
